<template>
  <v-card elevation="1" class="mt-0 py-lg-4" style="margin: 0 !important">
    <v-card-title style="color: var(--darkBlue)">
      <v-row>
        <v-col class="text-lg-left text-center d-flex align-center" cols="12">
          <div class="d-flex mb-2 mb-lg-0">
            <v-icon
              large
              class="mr-3"
              style="color: #0177d4 !important"
              id="menu-activator"
              @click="goBack"
            >
              mdi-arrow-left-bold
            </v-icon>
            <h5>{{ item.ListName }}</h5>
          </div>
          <v-spacer />
          <v-tooltip bottom v-if="!isCustomer">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                style="font-size: 32px"
                v-bind="attrs"
                v-on="on"
                color="var(--primaryColor)"
                @click="openUpdateModal"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>{{ $t('buttons.update') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider />

    <v-dialog
      v-model="updatePriceListModal"
      v-if="updatePriceListModal"
      max-width="750"
    >
      <v-card class="popup-card" elevation="1">
        <v-card-title class="popupHeadline" style="font-size: 24px">
          <div class="text-center popupHeadline" style="width: 100%">
            {{ $t('buttons.update') }}
          </div>
        </v-card-title>
        <v-divider class="mb-4" />

        <ValidationObserver
          ref="updatePriceListObserver"
          v-slot="{ handleSubmit }"
        >
          <form @submit.prevent="handleSubmit(update)">
            <v-card-text>
              <FormElement
                v-for="(element, index) in formItems"
                :key="
                  element.key.parent + '_' + element.key.child + '_' + index
                "
                :vertical="element.vertical"
                v-model="$data[element.key.parent][element.key.child]"
                :validationLabel="$t(element.validationLabel)"
                :rules="element.rules"
                :formLabel="$t(element.formLabel)"
                :onChange="element.onChange"
                :formType="element.formType"
                :cols="element.cols"
                :sm="element.sm"
                :md="element.md"
                :lg="element.lg"
                :light="false"
                :hidden="element.hidden"
                :labelShown="element.labelShown"
                :topLabel="element.topLabel"
                :active="element.active"
                :disabled="element.disabled"
                :placeholder="$t(element.placeholder)"
                :classes="element.classes"
              />
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                style="
                  color: #fff;
                  text-transform: unset !important;
                  background-color: #0077d5;

                  padding: 1vh 1vh;
                  border-radius: 30px !important;
                  font-weight: bolder;
                  font-size: medium;
                "
                elevation="0"
                class="darken-1"
                type="submit"
                :loading="saveLoading"
                >{{ $t('buttons.save') }}</v-btn
              >
              <v-btn
                style="
                  color: #fff;
                  text-transform: unset !important;
                  background-color: var(--red);
                  padding: 1vh 1vh;
                  border-radius: 30px !important;
                  font-weight: bolder;
                  font-size: medium;
                "
                elevation="0"
                class="darken-1"
                @click="updatePriceListModal = false"
                >{{ $t('buttons.cancel') }}</v-btn
              >
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <ConfirmationModal
      v-model="confirmationModal"
      :title="$t('labels.warning')"
      :message="$t('messages.changeTheExcelFile')"
      :confirm="finishExcelFileOperation"
    />
    <ValidationObserver
      v-if="priceData"
      ref="addChartEntryObserver"
      v-slot="{ handleSubmit }"
    >
      <form
        class="mt-5"
        autocomplete="off"
        @submit.prevent="handleSubmit(update)"
      >
        <v-card>
          <v-card-text style="padding: 0px; margin: 0px">
            <v-row class="px-4 pt-4">
              <FormElement
                key="ENTRY_REFERENCE_ID_2"
                :vertical="true"
                v-model="item.OptionalReferansId"
                :validationLabel="$t('labels.optionalReferenceID')"
                :topLabel="true"
                :labelShown="false"
                :cols="12"
                :sm="6"
                :md="4"
                :lg="3"
                :xl="2"
                disabled
                :placeholder="$t('labels.optionalReferenceID')"
              />
              <FormElement
                key="ENTRY_ID"
                :vertical="true"
                v-model="item.ReferanceId"
                :validationLabel="$t('labels.referenceId')"
                :topLabel="true"
                :labelShown="false"
                :cols="12"
                :sm="6"
                :md="4"
                :lg="3"
                :xl="2"
                :disabled="true"
                :formType="{
                  name: 'text',
                }"
                :placeholder="$t('labels.referenceId')"
              />
              <FormElement
                key="ENTRY_NAME"
                :vertical="true"
                v-model="item.ListName"
                :validationLabel="$t('labels.name')"
                rules="required"
                :topLabel="true"
                :labelShown="false"
                :cols="12"
                :sm="6"
                :md="4"
                :lg="3"
                :xl="2"
                :disabled="true"
                :formType="{
                  name: 'text',
                }"
                :placeholder="$t('labels.name')"
              />

              <FormElement
                key="ENTRY_EXPIRY_DATE_START"
                :vertical="true"
                v-model="item.ValidityStartDate"
                :validationLabel="$t('labels.expiryDateStart')"
                rules="required"
                :topLabel="true"
                :labelShown="false"
                :disabled="true"
                :cols="12"
                :sm="6"
                :md="4"
                :lg="3"
                :xl="2"
                :formType="{
                  name: 'date',
                  dateMode: 'date',
                }"
                :placeholder="$t('labels.expiryDateStart')"
              />

              <FormElement
                key="ENTRY_EXPIRY_DATE_END"
                :vertical="true"
                v-model="item.ValidityEndDate"
                :validationLabel="$t('labels.expiryDateEnd')"
                rules="required"
                :topLabel="true"
                :labelShown="false"
                :disabled="true"
                :cols="12"
                :sm="6"
                :md="4"
                :lg="3"
                :xl="2"
                :formType="{
                  name: 'date',
                  dateMode: 'date',
                }"
                :placeholder="$t('labels.expiryDateEnd')"
              />

              <FormElement
                key="ENTRY_COUNTRY"
                :vertical="true"
                v-model="priceData.Result.OriginCountry"
                :validationLabel="$t('labels.country')"
                rules="required"
                :topLabel="true"
                :labelShown="false"
                :lg="2"
                :disabled="true"
                :formType="{
                  name: 'text',
                }"
                :placeholder="$t('labels.country')"
              />

              <FormElement
                key="ENTRY_PORTAL_USERS"
                :vertical="true"
                v-model="item.PortalCompaniesString"
                :validationLabel="$t('labels.portalUsers')"
                :topLabel="true"
                :labelShown="false"
                :cols="12"
                :sm="6"
                :md="4"
                :lg="3"
                :xl="2"
                :disabled="true"
                :formType="{
                  name: 'text',
                }"
                :placeholder="$t('labels.portalUsers')"
              />

              <FormElement
                key="ENTRY_CURRENCY"
                :vertical="true"
                v-model="item.CurrencyCode"
                :validationLabel="$t('labels.currency')"
                rules="required"
                :topLabel="true"
                :labelShown="false"
                :lg="2"
                :disabled="true"
                :formType="{
                  name: 'text',
                }"
                :placeholder="$t('labels.currency')"
              />

              <FormElement
                key="ENTRY_SHIPMENT_TYPE"
                :vertical="true"
                v-model="item.ShipmentType"
                :validationLabel="$t('titles.shipmentType')"
                :disabled="true"
                :topLabel="true"
                :labelShown="false"
                :lg="2"
                :formType="{
                  name: 'select',
                  items: {
                    data: shipmentTypes,
                    value: 'Id',
                    text: 'Name',
                  },
                }"
                :placeholder="$t('titles.shipmentType')"
              />
            </v-row>
            <v-divider />
            <div style="position: relative; width: 100%">
              <template v-if="!isCustomer">
                <div
                  v-if="
                    !(activeTab == 2 && !outOfAreaData) &&
                    ($vuetify.breakpoint.xl ||
                      $vuetify.breakpoint.lg ||
                      $vuetify.breakpoint.md)
                  "
                  class="d-flex mt-6 px-4"
                  style="position: absolute; right: 0; top: 0; z-index: 1"
                >
                  <v-btn
                    style="border-radius: 12px !important"
                    elevation="0"
                    color="primary"
                    class="button"
                    dark
                    :href="
                      activeTab === 0
                        ? priceData?.Result?.PriceFileUrl
                        : priceData?.Result?.RegionFileUrl
                    "
                    depressed
                    download
                    ><v-icon left> mdi-download </v-icon
                    >{{ $t('buttons.downloadFile') }}</v-btn
                  >
                  <div class="ml-2">
                    <v-btn
                      style="border-radius: 12px !important"
                      elevation="0"
                      color="primary"
                      class="button"
                      dark
                      depressed
                      @click="fileUpload"
                    >
                      <v-icon left> mdi-upload </v-icon>
                      {{ $t('buttons.changeExcelFile') }}
                    </v-btn>
                    <input
                      ref="uploader"
                      class="d-none"
                      type="file"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      @change="onFileChanged"
                    />
                  </div>
                </div>
              </template>

              <div
                v-if="
                  !(activeTab == 2 && !outOfAreaData) &&
                  !(
                    $vuetify.breakpoint.xl ||
                    $vuetify.breakpoint.lg ||
                    $vuetify.breakpoint.md
                  )
                "
                class="d-flex mt-4 px-4"
                style="z-index: 1"
              >
                <v-btn
                  style="border-radius: 12px !important"
                  elevation="0"
                  color="primary"
                  class="button"
                  dark
                  :href="
                    activeTab === 0
                      ? priceData?.Result?.PriceFileUrl
                      : priceData?.Result?.RegionFileUrl
                  "
                  depressed
                  download
                  ><v-icon left> mdi-download </v-icon
                  >{{ $t('buttons.downloadFile') }}</v-btn
                >
                <div class="ml-2">
                  <v-btn
                    style="border-radius: 12px !important"
                    elevation="0"
                    color="primary"
                    class="button"
                    dark
                    depressed
                    @click="fileUpload"
                  >
                    <v-icon left> mdi-upload </v-icon>
                    {{ $t('buttons.changeExcelFile') }}
                  </v-btn>
                  <input
                    ref="uploader"
                    class="d-none"
                    type="file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    @change="onFileChanged"
                  />
                </div>
              </div>

              <TabScreen
                :slots="slots"
                :changeIndexFunction="onTabChange"
                class="px-4 pt-4"
              >
                <template v-slot:prices>
                  <div>
                    <v-simple-table
                      v-if="priceData"
                      border="2"
                      style="
                        width: 100%;
                        border-collapse: collapse;
                        border-radius: 0;
                        border-style: solid;
                        border-bottom-width: 1px;
                        border-left-width: 2px;
                        border-right-width: 2px;
                        border-top-width: 0px;
                        border-color: lightgray;
                      "
                    >
                      <thead>
                        <th
                          v-for="(item, index) in priceData.Result.Headers"
                          :key="index"
                        >
                          {{ item }}
                        </th>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in priceData.Result.Values"
                          :key="index"
                        >
                          <td
                            style="padding: 0 25px; text-align: center"
                            v-for="(value, valueIndex) in item"
                            :key="valueIndex"
                          >
                            {{ value ? value : '-' }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>
                </template>
                <template v-slot:regions>
                  <div
                    style="
                      border-radius: 0;
                      border-style: solid;
                      border-bottom-width: 1px;
                      border-left-width: 2px;
                      border-right-width: 2px;
                      border-top-width: 0px;
                      border-color: lightgray;
                    "
                  >
                    <v-text-field
                      v-model="filterText"
                      :label="$t('labels.filterCountry')"
                      outlined
                      dense
                      clearable
                      class="mb-4"
                    ></v-text-field>
                    <v-data-table
                      :no-data-text="$t('messages.noData')"
                      @update:sort-desc="sort"
                      :headers="[
                        {
                          text: $t('labels.country'),
                          value: 'CountryName',
                          sortable: true,
                          groupable: false,
                          align: 'center',
                        },
                        {
                          text: $t('labels.region'),
                          value: 'RegionName',
                          sortable: true,
                          groupable: false,
                          align: 'center',
                        },
                        {
                          text: $t('labels.minZipCode'),
                          value: 'MinZipCode',
                          sortable: true,
                          groupable: false,
                          align: 'center',
                        },
                        {
                          text: $t('labels.maxZipCode'),
                          value: 'MaxZipCode',
                          sortable: true,
                          groupable: false,
                          align: 'center',
                        },
                        {
                          text: $t('titles.transferTime'),
                          value: 'TransitTime',
                          sortable: true,
                          groupable: false,
                          align: 'center',
                        },
                      ]"
                      :loading="$store.state.loadingStatus"
                      :options="{
                        itemsPerPage: itemsPerPage,
                        page: page,
                        sortBy: ['Region', 'DestinationCountry'],
                        sortDesc: [sortDesc],
                      }"
                      hide-default-footer
                      :items="filteredRegions"
                      :item-key="'DestinationCountry' + new Date().getTime()"
                    >
                      <template v-slot:footer>
                        <div class="d-flex justify-center mt-8">
                          <v-row align="center" justify="center">
                            <v-col
                              v-if="
                                $vuetify.breakpoint.md ||
                                $vuetify.breakpoint.lg ||
                                $vuetify.breakpoint.xl
                              "
                              md="2"
                            ></v-col>
                            <v-col cols="9" sm="12" md="7" lg="7" xl="7">
                              <v-pagination
                                class="my-4"
                                @input="onPageChange"
                                :value="page"
                                :length="pageLength"
                                circle
                                :total-visible="
                                  $vuetify.breakpoint.xs ? 10 : 10
                                "
                              ></v-pagination>
                            </v-col>
                            <v-col
                              cols="11"
                              sm="11"
                              md="3"
                              lg="3"
                              xl="3"
                              class="ml-md-auto d-flex align-center mb-6 mb-md-0 pr-3 pr-md-6"
                            >
                              <v-select
                                v-model="itemsPerPage"
                                :items="[5, 10, 15, 20, 50, 100, 1000]"
                                :label="$t('labels.selectItemsPerPage')"
                                item-value="value"
                                item-text="name"
                                outlined
                                dense
                                hide-details
                                @change="changeItemsPerPage"
                                rounded
                              >
                              </v-select>
                            </v-col>
                          </v-row>
                        </div>
                      </template>
                    </v-data-table>
                  </div>
                </template>
              </TabScreen>
            </div>
          </v-card-text>
          <v-card-actions class="d-flex justify-center"> </v-card-actions>
        </v-card>
      </form>
    </ValidationObserver>
  </v-card>
</template>
<script>
import PartialTransportationServices from '../services/PartialTransportationServices';
import {
  ITEMS_PER_PAGE_OPTIONS,
  shipmentTypes,
  getCurrencyTypes,
} from '../utils/constants';
import FormElement from '../components/FormElement.vue';
import formatDate from '../utils/formatDate';
import TabScreen from '../components/TabScreen.vue';
import ConfirmationModal from '../components/General/ConfirmationModal.vue';
import PortalService from '../services/PortalService';

export default {
  data() {
    return {
      item: {},
      shipmentTypes,
      priceData: null,
      slots: [],
      isSelecting: false,
      file: null,
      priceExcel: null,
      page: 1,
      itemsPerPage: 10,
      updatePriceListModal: false,
      confirmationModal: false,
      form: {},
      saveLoading: false,
      sortDesc: null,
      activeTab: 0,
      filterText: '',
      currencies: [],
      portalUsers: [],
    };
  },
  components: { FormElement, TabScreen, ConfirmationModal },
  async mounted() {
    this.item = this.$route.params.item;
    console.log(this.item);
    if (!this.item) this.$router.push('partial-transportation');
    else {
      this.slots = [
        {
          name: 'prices',
          title: this.$t('labels.priceList'),
          unSeenCount: 0,
        },
        {
          name: 'regions',
          title: this.$t('labels.regionList'),
          unSeenCount: 0,
        },
      ];

      this.$store.state.loadingStatus = true;
      this.itemsPerPageOptions = ITEMS_PER_PAGE_OPTIONS;
      await this.setup();

      // Initialize PortalCompaniesString if not present
      if (
        !this.item.PortalCompaniesString &&
        this.item.PortalCompanyIds &&
        this.item.PortalCompanyIds.length > 0 &&
        this.portalUsers.length > 0
      ) {
        const selectedNames = this.portalUsers
          .filter((user) => this.item.PortalCompanyIds.includes(user.Id))
          .map((user) => user.Name);
        this.item.PortalCompaniesString = selectedNames.join(',');
      } else if (
        this.item.PortalCompanies &&
        Array.isArray(this.item.PortalCompanies)
      ) {
        this.item.PortalCompaniesString = this.item.PortalCompanies.join(',');
      }

      // Initialize form after currencies are loaded
      let currencyId = this.item.CurrencyId;
      if (!currencyId && this.item.CurrencyCode && this.currencies.length > 0) {
        const currency = this.currencies.find(
          (c) => c.Code === this.item.CurrencyCode
        );
        currencyId = currency ? currency.Id : null;
      }

      this.form = {
        isActive: this.item.isActive,
        OptionalReferansId: this.item.OptionalReferansId || '',
        ValidityStartDate: this.item.ValidityStartDate,
        ValidityEndDate: this.item.ValidityEndDate,
        ListName: this.item.ListName,
        CargoName: this.item.CargoName || '',
        CurrencyId: currencyId,
        PortalCompanyIds: this.item.PortalCompanyIds || [],
      };
    }
  },
  watch: {},
  computed: {
    isCustomer() {
      return (
        this.$store.state.Type === 'Customer' ||
        this.$store.state.Type === 'PendingCustomer'
      );
    },
    formItems() {
      return [
        {
          key: {
            parent: 'form',
            child: 'isActive',
          },
          validationLabel: 'labels.isActive',
          formType: {
            name: 'checkbox',
          },
          lg: 6,
          labelShown: false,
          topLabel: true,
          cols: 12,
          disabled: this.isCustomer,
          placeholder: 'labels.isActive',
          classes: 'mb-4',
        },
        {
          key: {
            parent: 'form',
            child: 'OptionalReferansId',
          },
          validationLabel: 'labels.optionalReferenceID',
          formType: {
            name: 'text',
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          disabled: this.isCustomer,
          placeholder: 'labels.optionalReferenceID',
        },
        {
          key: {
            parent: 'form',
            child: 'ListName',
          },
          validationLabel: 'labels.name',
          rules: 'required',
          formType: {
            name: 'text',
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          disabled: this.isCustomer,
          placeholder: 'labels.name',
        },
        {
          key: {
            parent: 'form',
            child: 'CargoName',
          },
          validationLabel: 'labels.priceListName',
          formType: {
            name: 'text',
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          disabled: this.isCustomer,
          placeholder: 'labels.priceListName',
        },
        {
          key: {
            parent: 'form',
            child: 'ValidityStartDate',
          },
          validationLabel: 'labels.expiryDateStart',
          rules: 'required',
          formType: {
            name: 'date',
            dateMode: 'date',
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          disabled: this.isCustomer,
          placeholder: 'labels.expiryDateStart',
        },
        {
          key: {
            parent: 'form',
            child: 'ValidityEndDate',
          },
          validationLabel: 'labels.expiryDateEnd',
          rules: 'required',
          formType: {
            name: 'date',
            dateMode: 'date',
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          disabled: this.isCustomer,
          placeholder: 'labels.expiryDateEnd',
        },
        {
          key: {
            parent: 'form',
            child: 'CurrencyId',
          },
          rules: 'required',
          validationLabel: 'labels.currency',
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.currencies,
              value: 'Id',
              text: 'Code',
            },
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          disabled: this.isCustomer,
          placeholder: 'labels.currency',
        },
        {
          key: {
            parent: 'form',
            child: 'PortalCompanyIds',
          },
          formType: {
            name: 'checkTable',
            unselectedItems: this.portalUsers,
            selectedItems: this.form.PortalCompanyIds,
          },
          labelShown: false,
          disabled: this.isCustomer,
        },
      ];
    },
    filteredRegions() {
      if (!this.filterText) {
        return this.priceData.Result.Regions;
      }
      const filter = this.filterText
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      return this.priceData.Result.Regions.filter((region) =>
        region.CountryName.toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .includes(filter)
      );
    },
    pageLength() {
      return Math.ceil(
        this.priceData?.Result?.Regions?.length / this.itemsPerPage
      );
    },
  },
  methods: {
    openUpdateModal() {
      if (this.isCustomer) return;
      let currencyId = this.item.CurrencyId;
      if (!currencyId && this.item.CurrencyCode && this.currencies.length > 0) {
        const currency = this.currencies.find(
          (c) => c.Code === this.item.CurrencyCode
        );
        currencyId = currency ? currency.Id : null;
      }

      // Ensure PortalCompaniesString is initialized
      if (
        !this.item.PortalCompaniesString &&
        this.item.PortalCompanyIds &&
        this.item.PortalCompanyIds.length > 0 &&
        this.portalUsers.length > 0
      ) {
        const selectedNames = this.portalUsers
          .filter((user) => this.item.PortalCompanyIds.includes(user.Id))
          .map((user) => user.Name);
        this.item.PortalCompaniesString = selectedNames.join(',');
      } else if (
        this.item.PortalCompanies &&
        Array.isArray(this.item.PortalCompanies)
      ) {
        this.item.PortalCompaniesString = this.item.PortalCompanies.join(',');
      }

      this.form = {
        isActive: this.item.isActive,
        OptionalReferansId: this.item.OptionalReferansId || '',
        ValidityStartDate: this.item.ValidityStartDate,
        ValidityEndDate: this.item.ValidityEndDate,
        ListName: this.item.ListName,
        CargoName: this.item.CargoName || '',
        CurrencyId: currencyId,
        PortalCompanyIds: this.item.PortalCompanyIds || [],
      };
      this.updatePriceListModal = true;
    },
    onTabChange(index) {
      this.activeTab = index;
    },
    sort(item) {
      this.sortDesc = !!item;
    },
    goBack() {
      if (this.$router.getRoutes().length === 0) {
        this.$router.push({ name: 'PriceChartEntry' });
      } else {
        this.$router.go(-1);
      }
    },

    fileUpload() {
      if (this.isCustomer) return;
      this.isSelecting = true;
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.file = e.target.files[0];
      this.confirmationModal = true;
    },
    finishExcelFileOperation() {
      this.$store.state.loadingStatus = true;

      if (this.activeTab === 0) {
        let body = {
          PartialPriceId: this.priceData.Result.Id,
          PriceExcel: this.file,
        };

        PartialTransportationServices.updatePriceExcel(body)
          .then((response) => {
            window.showSuccess(this.$t('messages.updatePriceExcel'));
            this.getPriceExcel();
          })
          .catch((err) => {
            window.showError(err);
          })
          .finally(() => {
            this.$store.state.loadingStatus = false;
          });
      } else {
        let body = {
          RegionExcelId: this.priceData.Result.RegionExcelId,
          RegionExcel: this.file,
        };

        PartialTransportationServices.updateRegionExcel(body)
          .then((response) => {
            window.showSuccess(this.$t('messages.updateRegionExcel'));
            this.getPriceExcel();
          })
          .catch((err) => {
            window.showError(err);
          })
          .finally(() => {
            this.$store.state.loadingStatus = false;
          });
      }
    },
    // finishExcelFileOperation() {
    //   let service = null,
    //     formData = new FormData(),
    //     finalService = null;
    //   if (this.activeTab === 0) {
    //     service = ExpressCargoServices.updatePriceExcel;
    //     formData.append('PriceExcelId', this.item.PriceExcelId);
    //     finalService = this.getPriceExcel;
    //     this.selectedFiles.priceExcel = this.file;
    //   } else {
    //     service = ExpressCargoServices.updateRegionExcel;
    //     formData.append('RegionExcelId', this.item.RegionExcelId);
    //     formData.append(
    //       'OriginCountryId',
    //       this.regionData.Result.OriginCountryId
    //     );
    //     finalService = this.getRegionExcel;
    //     this.selectedFiles.regionExcel = this.file;
    //   }

    //   formData.append('File', this.file);

    //   if (service) {
    //     this.$store.state.loadingStatus = true;
    //     service(formData)
    //       .then((response) => {
    //         window.showSuccess(this.$t('messages.changeFileSuccessful'));
    //         finalService();
    //       })
    //       .catch(this.onServiceError)
    //       .finally(() => {
    //         this.$store.state.loadingStatus = false;
    //       });
    //   }
    // },
    update() {
      this.$store.state.loadingStatus = true;
      this.saveLoading = true;

      let body = {
        PriceListId: this.item.Id,
        isActive: this.form.isActive,
        OptionalReferansId: this.form.OptionalReferansId,
        ListName: this.form.ListName,
        CargoName: this.form.CargoName,
        ValidityStartDate: this.form.ValidityStartDate,
        ValidityEndDate: this.form.ValidityEndDate,
        ExportImportType: this.item.ExportImportType,
        PortalCompanyIds: this.form.PortalCompanyIds,
        CurrencyId: this.form.CurrencyId,
      };

      PartialTransportationServices.updatePriceList(body)
        .then((response) => {
          window.showSuccess(this.$t('messages.updateActiveExpress'));
          const data = response.data.Result;

          this.item.isActive = this.form.isActive;
          this.item.OptionalReferansId = this.form.OptionalReferansId;
          this.item.ListName = this.form.ListName;
          this.item.CargoName = this.form.CargoName;
          this.item.ValidityStartDate = this.form.ValidityStartDate;
          this.item.ValidityEndDate = this.form.ValidityEndDate;
          this.item.CurrencyId = this.form.CurrencyId;
          this.item.CurrencyCode =
            this.currencies.find((c) => c.Id === this.form.CurrencyId)?.Code ||
            this.item.CurrencyCode;

          if (data.PortalCompanyNames) {
            this.item.PortalCompanies = data.PortalCompanyNames.split(',');
            this.item.PortalCompanyIds = data.PortalCompanyIds;
            this.item.PortalCompaniesString = data.PortalCompanyNames;
          } else if (
            this.form.PortalCompanyIds &&
            this.form.PortalCompanyIds.length > 0
          ) {
            // If PortalCompanyNames is not returned, construct from selected IDs
            const selectedNames = this.portalUsers
              .filter((user) => this.form.PortalCompanyIds.includes(user.Id))
              .map((user) => user.Name);
            this.item.PortalCompaniesString = selectedNames.join(',');
            this.item.PortalCompanyIds = this.form.PortalCompanyIds;
          }

          this.updatePriceListModal = false;
        })
        .catch((err) => {
          window.showError(err);
        })
        .finally(() => {
          this.$store.state.loadingStatus = false;
          this.saveLoading = false;
        });
    },

    updateTransportTime() {
      //
      // Servis bekleniyor
      //
      // this.$store.state.loadingStatus = true;
      // let body = {
      //   PriceListId: this.item.Id,
      //   TransportTime: this.form.TransportTime,
      // };
      // PartialTransportationServices.updateTransportTime(body)
      //   .then((response) => {
      //     window.showSuccess(this.$t('messages.updateTransportTime'));
      //     this.item.TransportTime = this.form.TransportTime;
      //     this.updateTransportTimeModal = false;
      //   })
      //   .catch(this.onServiceError)
      //   .finally(() => {
      //     this.$store.state.loadingStatus = false;
      //   });
    },
    /**
     * Format the date and returns it as a string.
     * @param {Date} date
     * @returns {string}
     */
    getFormattedDate(date) {
      return formatDate(date, '/');
    },

    changeItemsPerPage(newValue) {
      this.page = 1;
      this.itemsPerPage = newValue;
    },

    /**
     * Trigger when page changed.
     */
    onPageChange(newPage) {
      this.page = newPage;
    },

    async setup() {
      this.getPriceExcel();
      this.currencies = await getCurrencyTypes();
      this.getPortalUsers();
    },
    getPortalUsers() {
      this.$store.state.loadingStatus = true;
      PortalService.getPortalUsers(null, null, null, null, 1, 999999999)
        .then((response) => {
          this.portalUsers = response.data.Result.PortalCompanies;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    getPriceExcel() {
      PartialTransportationServices.getPriceDetail(this.item.Id)
        .then((response) => {
          this.priceData = response?.data;
          console.log(this.priceData);
        })
        .catch((err) => {
          window.showError(err);
        })
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
  },
};
</script>
<style>
.container {
  margin-top: 38px;
}

.offerFormSheet {
  padding: 30px;
}

.activeRadioButton {
  color: var(--pink) !important;
}

.color-pink {
  color: var(--pink) !important;
  font-weight: bold;
}

.bold-cell {
  font-weight: bold;
}

.regular-cell {
  color: #575454;
}
</style>
